import { type ColumnCellTemplateProps } from '@adv-frontend/grid';

export function getCellDataTestId<RowData extends { id: string }>({ column, data }: ColumnCellTemplateProps<RowData>) {
    return `Cell.${column.id}.${data.id}`;
}
